import { defaultTheme } from './index';
import colors from './dark-colors.module.scss';

const defaultDark = {
  ...defaultTheme,
  palette: {
    ...defaultTheme.palette,
    mode: 'dark',
    primary: {
      ...defaultTheme.palette.primary,
      background: colors.background,
      summaryPanel: colors.darkBlue,
      grey2: colors.darkSteelGrey,
      grey25: colors.darkSteelGrey,
      grey14: colors.grey14,
      grey13: colors.grey13,
      grey12: colors.white,
      trellisLightBlue: colors.lightSilver,
      trellisBlue: colors.darkBlue,
      faintBorder: colors.darkSteelGrey,
      silverGrey: colors.silverGrey,
      steelGrey: colors.steelGrey,
      formLabel: colors.formLabel,
      formItem: colors.formItem,
      redWhite: colors.darkRed,
      darkRed: colors.white,
      bluesky: colors.lightSilver,
      deepChestnutRed: colors.darkSteelGrey,
      deepBlue: colors.deepBlue2,
      darkGreen: colors.darkGreen,
      task: {
        borderColor: colors.formItem,
        checked: colors.white,
        number: colors.darkBlue,
      },
      disabled: colors.steelGrey,
    },
    verification: {
      nonVerifyContainer: colors.darkRed,
      verificationBtn: colors.darkRed,
      verifyWording: colors.white,
      nonVerifyWording: colors.white,
    },
    secondary: { main: colors.textSilver },
    text: {
      primary: colors.textSilver,
      secondary: colors.textSilver,
      success: colors.patina,
    },
  },
};

export default defaultDark;
